import { inject, Injectable, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { TenderType } from "../services/model/tender-type.enum";

@Pipe({ name: "paymentType", pure: true })
@Injectable({
  providedIn: "root",
})
export class PaymentTypePipe implements PipeTransform {
  private readonly _translate = inject(TranslateService);

  transform(value: any): string {
    switch (value) {
      case TenderType.Card:
        return this._translate.instant("webPos.Card");
      case TenderType.Cash:
        return this._translate.instant("webPos.Cash");
      case TenderType.ElectronicVoucher:
        return this._translate.instant("webPos.ElectronicVoucher");
      case TenderType.Cheque:
      case TenderType.Virtual:
        return this._translate.instant("webPos.Benefits");
      case TenderType.Voucher:
        return this._translate.instant("webPos.Voucher.Voucher");
      default:
        return value;
    }
  }
}
